var map = {
	"./API/Index": 23446,
	"./API/Index.vue": 23446,
	"./API/Partials/ApiTokenManager": 31560,
	"./API/Partials/ApiTokenManager.vue": 31560,
	"./Attendance/AttendanceSheet": 2511,
	"./Attendance/AttendanceSheet.vue": 2511,
	"./Attendance/Component/AttendHistory": 2563,
	"./Attendance/Component/AttendHistory.vue": 2563,
	"./Attendance/Component/AttendSummary": 12725,
	"./Attendance/Component/AttendSummary.vue": 12725,
	"./Attendance/Component/Calender": 62619,
	"./Attendance/Component/Calender.vue": 62619,
	"./Attendance/Component/Checkin": 15135,
	"./Attendance/Component/Checkin.vue": 15135,
	"./Attendance/Component/Leave": 46443,
	"./Attendance/Component/Leave copy": 32021,
	"./Attendance/Component/Leave copy.vue": 32021,
	"./Attendance/Component/Leave.vue": 46443,
	"./Attendance/Component/TimingOverview": 73724,
	"./Attendance/Component/TimingOverview.vue": 73724,
	"./Auth/ConfirmPassword": 60859,
	"./Auth/ConfirmPassword.vue": 60859,
	"./Auth/ForgotPassword": 90986,
	"./Auth/ForgotPassword.vue": 90986,
	"./Auth/Login": 63352,
	"./Auth/Login.vue": 63352,
	"./Auth/Register": 46716,
	"./Auth/Register.vue": 46716,
	"./Auth/ResetPassword": 66390,
	"./Auth/ResetPassword.vue": 66390,
	"./Auth/TwoFactorChallenge": 302,
	"./Auth/TwoFactorChallenge.vue": 302,
	"./Auth/VerifyEmail": 91808,
	"./Auth/VerifyEmail.vue": 91808,
	"./BaseLayouts/Create": 9272,
	"./BaseLayouts/Create.vue": 9272,
	"./BaseLayouts/Edit": 34604,
	"./BaseLayouts/Edit.vue": 34604,
	"./BaseLayouts/Index": 6218,
	"./BaseLayouts/Index.vue": 6218,
	"./BaseLayouts/LayoutSwitch": 46451,
	"./BaseLayouts/LayoutSwitch.vue": 46451,
	"./BaseLayouts/LeaveIndex": 18815,
	"./BaseLayouts/LeaveIndex.vue": 18815,
	"./BaseLayouts/ProductShow": 67016,
	"./BaseLayouts/ProductShow.vue": 67016,
	"./BaseLayouts/Show": 98405,
	"./BaseLayouts/Show copy": 52142,
	"./BaseLayouts/Show copy.vue": 52142,
	"./BaseLayouts/Show.vue": 98405,
	"./Billingacc": 5028,
	"./Billingacc.vue": 5028,
	"./Builder/Fields/ModuleFieldCreate": 10535,
	"./Builder/Fields/ModuleFieldCreate.vue": 10535,
	"./Builder/Fields/data": 57233,
	"./Builder/Fields/data.js": 57233,
	"./Builder/Layouts/ModuleLayouts": 80960,
	"./Builder/Layouts/ModuleLayouts.vue": 80960,
	"./Builder/Layouts/SubComponents/DetailViewLayout": 61136,
	"./Builder/Layouts/SubComponents/DetailViewLayout.vue": 61136,
	"./Builder/Layouts/SubComponents/EditViewLayout": 48635,
	"./Builder/Layouts/SubComponents/EditViewLayout.vue": 48635,
	"./Builder/Layouts/SubComponents/InvoiceItemViewLayout": 52522,
	"./Builder/Layouts/SubComponents/InvoiceItemViewLayout.vue": 52522,
	"./Builder/Layouts/SubComponents/LineItemViewLayout": 67634,
	"./Builder/Layouts/SubComponents/LineItemViewLayout.vue": 67634,
	"./Builder/Layouts/SubComponents/ListViewLayout": 20166,
	"./Builder/Layouts/SubComponents/ListViewLayout.vue": 20166,
	"./Builder/Layouts/SubComponents/QuickCreateLayout": 32932,
	"./Builder/Layouts/SubComponents/QuickCreateLayout.vue": 32932,
	"./Builder/Layouts/SubComponents/data": 29160,
	"./Builder/Layouts/SubComponents/data.js": 29160,
	"./Builder/ModuleCreate": 74847,
	"./Builder/ModuleCreate.vue": 74847,
	"./Builder/ModuleEdit": 5053,
	"./Builder/ModuleEdit.vue": 5053,
	"./Builder/ModuleList": 76433,
	"./Builder/ModuleList.vue": 76433,
	"./Builder/ModuleShow": 70204,
	"./Builder/ModuleShow.vue": 70204,
	"./Builder/Relationships/ModuleRelationshipBuilder": 91125,
	"./Builder/Relationships/ModuleRelationshipBuilder.vue": 91125,
	"./Builder/base": 91566,
	"./Builder/base.js": 91566,
	"./CRMSync": 7769,
	"./CRMSync.vue": 7769,
	"./CstmIndex": 88368,
	"./CstmIndex.vue": 88368,
	"./Dashboard": 85461,
	"./Dashboard.vue": 85461,
	"./Dashboard2": 96993,
	"./Dashboard2.vue": 96993,
	"./DashboardCompo": 94079,
	"./DashboardCompo.vue": 94079,
	"./Index/AboutUs": 91539,
	"./Index/AboutUs.vue": 91539,
	"./Index/Support": 39105,
	"./Index/Support.vue": 39105,
	"./Integrate/ImportTemplates/import_voucher_template": 84435,
	"./Integrate/ImportTemplates/import_voucher_template.vue": 84435,
	"./Integrate/Utils/js/util": 7681,
	"./Integrate/Utils/js/util.js": 7681,
	"./Interface/Default": 32744,
	"./Interface/Default.vue": 32744,
	"./Interface/Whatsapp": 24426,
	"./Interface/Whatsapp.vue": 24426,
	"./Interface/WhatsappScreen": 25333,
	"./Interface/WhatsappScreen.vue": 25333,
	"./Interface/WhatsappSettings": 36263,
	"./Interface/WhatsappSettings.vue": 36263,
	"./Interface/WhatsappSide": 97159,
	"./Interface/WhatsappSide.vue": 97159,
	"./Interface/chat": 14698,
	"./Interface/chat.vue": 14698,
	"./Interface/coming": 96001,
	"./Interface/coming.vue": 96001,
	"./Interface/timeManage": 53554,
	"./Interface/timeManage.vue": 53554,
	"./Organisations": 66391,
	"./Organisations.vue": 66391,
	"./Popup": 78938,
	"./Popup.vue": 78938,
	"./PrivacyPolicy": 23944,
	"./PrivacyPolicy.vue": 23944,
	"./Products/Booksdetail": 99226,
	"./Products/Booksdetail.vue": 99226,
	"./Products/Integrate": 90393,
	"./Products/Integrate.vue": 90393,
	"./Products/Login": 26827,
	"./Products/Login.vue": 26827,
	"./Products/Manage": 55054,
	"./Products/Manage.vue": 55054,
	"./Products/Paytimedetail": 30032,
	"./Products/Paytimedetail.vue": 30032,
	"./Products/Register": 68234,
	"./Products/Register.vue": 68234,
	"./Products/Service": 32979,
	"./Products/Service.vue": 32979,
	"./Products/Subscribedetail": 38271,
	"./Products/Subscribedetail.vue": 38271,
	"./Products/TallyAddons": 39080,
	"./Products/TallyAddons.vue": 39080,
	"./Products/TallyModules": 8330,
	"./Products/TallyModules.vue": 8330,
	"./Products/TallyOnCloud": 75848,
	"./Products/TallyOnCloud.vue": 75848,
	"./Products/Training": 89033,
	"./Products/Training.vue": 89033,
	"./Products/Webinar": 96732,
	"./Products/Webinar.vue": 96732,
	"./Products/crm/Detailview": 99412,
	"./Products/crm/Detailview.vue": 99412,
	"./Products/crm/Listview": 87612,
	"./Products/crm/Listview.vue": 87612,
	"./Products/paytime/AddExpense": 33895,
	"./Products/paytime/AddExpense.vue": 33895,
	"./Products/paytime/AttendanceLeavesSummary": 34657,
	"./Products/paytime/AttendanceLeavesSummary.vue": 34657,
	"./Products/paytime/AttendanceMenu": 59730,
	"./Products/paytime/AttendanceMenu.vue": 59730,
	"./Products/paytime/ExpenseSelection": 56788,
	"./Products/paytime/ExpenseSelection.vue": 56788,
	"./Products/paytime/Home": 23481,
	"./Products/paytime/Home.vue": 23481,
	"./Products/paytime/Payslips": 70132,
	"./Products/paytime/Payslips.vue": 70132,
	"./Products/paytime/PunchIn": 7121,
	"./Products/paytime/PunchIn.vue": 7121,
	"./Products/paytime/YourExpenses": 63079,
	"./Products/paytime/YourExpenses.vue": 63079,
	"./Products/productsjson/products": 84285,
	"./Products/productsjson/products.json": 84285,
	"./Profile/Partials/ActionSection": 84382,
	"./Profile/Partials/ActionSection.vue": 84382,
	"./Profile/Partials/DeleteUserForm": 94979,
	"./Profile/Partials/DeleteUserForm.vue": 94979,
	"./Profile/Partials/FormSection": 39847,
	"./Profile/Partials/FormSection.vue": 39847,
	"./Profile/Partials/LogoutOtherBrowserSessionsForm": 87890,
	"./Profile/Partials/LogoutOtherBrowserSessionsForm.vue": 87890,
	"./Profile/Partials/TwoFactorAuthenticationForm": 88466,
	"./Profile/Partials/TwoFactorAuthenticationForm.vue": 88466,
	"./Profile/Partials/UpdatePasswordForm": 85094,
	"./Profile/Partials/UpdatePasswordForm.vue": 85094,
	"./Profile/Partials/UpdateProfileInformationForm": 75434,
	"./Profile/Partials/UpdateProfileInformationForm.vue": 75434,
	"./Profile/Show": 70378,
	"./Profile/Show.vue": 70378,
	"./Profile/talltcolor2.png": 9573,
	"./SecondDashboard": 82270,
	"./SecondDashboard.vue": 82270,
	"./Subscription": 82252,
	"./Subscription.vue": 82252,
	"./TallyClinic/Coming_Soon": 4152,
	"./TallyClinic/Coming_Soon.vue": 4152,
	"./TallyClinic/CreateTemplates/CreateLedgerTemplate/create_ledger_template": 32647,
	"./TallyClinic/CreateTemplates/CreateLedgerTemplate/create_ledger_template.vue": 32647,
	"./TallyClinic/CreateTemplates/CreateStockItemTemplate/create_stock_item_template": 79459,
	"./TallyClinic/CreateTemplates/CreateStockItemTemplate/create_stock_item_template.vue": 79459,
	"./TallyClinic/CreateTemplates/MissingMastersPopup/Modal": 57673,
	"./TallyClinic/CreateTemplates/MissingMastersPopup/Modal.vue": 57673,
	"./TallyClinic/CreateTemplates/MissingMastersPopup/excel_dataview_popup": 63770,
	"./TallyClinic/CreateTemplates/MissingMastersPopup/excel_dataview_popup.vue": 63770,
	"./TallyClinic/CreateTemplates/MissingMastersPopup/modal_popup": 24573,
	"./TallyClinic/CreateTemplates/MissingMastersPopup/modal_popup.vue": 24573,
	"./TallyClinic/CreateTemplates/accountingallocations": 6149,
	"./TallyClinic/CreateTemplates/accountingallocations.vue": 6149,
	"./TallyClinic/CreateTemplates/bankallocation": 69223,
	"./TallyClinic/CreateTemplates/bankallocation.vue": 69223,
	"./TallyClinic/CreateTemplates/batchallocations": 55679,
	"./TallyClinic/CreateTemplates/batchallocations.vue": 55679,
	"./TallyClinic/CreateTemplates/billallocation": 71443,
	"./TallyClinic/CreateTemplates/billallocation.vue": 71443,
	"./TallyClinic/CreateTemplates/create_voucher_template": 28056,
	"./TallyClinic/CreateTemplates/create_voucher_template.vue": 28056,
	"./TallyClinic/CreateTemplates/inventoryentry": 69965,
	"./TallyClinic/CreateTemplates/inventoryentry.vue": 69965,
	"./TallyClinic/CreateTemplates/ledgerentry": 20523,
	"./TallyClinic/CreateTemplates/ledgerentry.vue": 20523,
	"./TallyClinic/EditTemplate/accountingallocations": 87398,
	"./TallyClinic/EditTemplate/accountingallocations.vue": 87398,
	"./TallyClinic/EditTemplate/bankallocation": 45485,
	"./TallyClinic/EditTemplate/bankallocation.vue": 45485,
	"./TallyClinic/EditTemplate/batchallocations": 7363,
	"./TallyClinic/EditTemplate/batchallocations.vue": 7363,
	"./TallyClinic/EditTemplate/billallocation": 4535,
	"./TallyClinic/EditTemplate/billallocation.vue": 4535,
	"./TallyClinic/EditTemplate/editLedgerTemplate/edit_ledger_template": 11447,
	"./TallyClinic/EditTemplate/editLedgerTemplate/edit_ledger_template.vue": 11447,
	"./TallyClinic/EditTemplate/editStockItemTemplate/edit_stock_item_template": 71339,
	"./TallyClinic/EditTemplate/editStockItemTemplate/edit_stock_item_template.vue": 71339,
	"./TallyClinic/EditTemplate/edit_voucher_template": 94562,
	"./TallyClinic/EditTemplate/edit_voucher_template.vue": 94562,
	"./TallyClinic/EditTemplate/inventoryentry": 93404,
	"./TallyClinic/EditTemplate/inventoryentry.vue": 93404,
	"./TallyClinic/EditTemplate/ledgerentry": 35936,
	"./TallyClinic/EditTemplate/ledgerentry.vue": 35936,
	"./TallyClinic/ImportTemplates/stepform": 14186,
	"./TallyClinic/ImportTemplates/stepform.vue": 14186,
	"./TallyClinic/ImportTemplates/stepform_11": 45352,
	"./TallyClinic/ImportTemplates/stepform_11.vue": 45352,
	"./TallyClinic/Settings/setting": 80453,
	"./TallyClinic/Settings/setting.vue": 80453,
	"./TallyClinic/Utils/js/dashboard/dashboard": 42653,
	"./TallyClinic/Utils/js/dashboard/dashboard.js": 42653,
	"./TallyClinic/Utils/js/editTemplate/editTemplate": 3487,
	"./TallyClinic/Utils/js/editTemplate/editTemplate.js": 3487,
	"./TallyClinic/Utils/js/import/excel_data_view": 69038,
	"./TallyClinic/Utils/js/import/excel_data_view.js": 69038,
	"./TallyClinic/Utils/js/import/import_tally": 6512,
	"./TallyClinic/Utils/js/import/import_tally.js": 6512,
	"./TallyClinic/Utils/js/import/jquery_related_js": 42942,
	"./TallyClinic/Utils/js/import/jquery_related_js.js": 42942,
	"./TallyClinic/Utils/js/import/master_creation": 96472,
	"./TallyClinic/Utils/js/import/master_creation.js": 96472,
	"./TallyClinic/Utils/js/modal_popup/data_view_popup": 82632,
	"./TallyClinic/Utils/js/modal_popup/data_view_popup.js": 82632,
	"./TallyClinic/Utils/js/modal_popup/modal_popup_db": 71874,
	"./TallyClinic/Utils/js/modal_popup/modal_popup_db.js": 71874,
	"./TallyClinic/Utils/js/modal_popup/modal_popup_tally": 46416,
	"./TallyClinic/Utils/js/modal_popup/modal_popup_tally.js": 46416,
	"./TallyClinic/Utils/js/template/ledger_template_db": 88618,
	"./TallyClinic/Utils/js/template/ledger_template_db.js": 88618,
	"./TallyClinic/Utils/js/template/stockitem_template_db": 46706,
	"./TallyClinic/Utils/js/template/stockitem_template_db.js": 46706,
	"./TallyClinic/Utils/js/template/template_db": 63400,
	"./TallyClinic/Utils/js/template/template_db.js": 63400,
	"./TallyClinic/Utils/js/template/xml_resolver": 30289,
	"./TallyClinic/Utils/js/template/xml_resolver.js": 30289,
	"./TallyClinic/Utils/js/utils/utils": 53585,
	"./TallyClinic/Utils/js/utils/utils.js": 53585,
	"./TallyClinic/Utils/store": 15914,
	"./TallyClinic/Utils/store/": 15914,
	"./TallyClinic/Utils/store/index": 15914,
	"./TallyClinic/Utils/store/index.js": 15914,
	"./TallyClinic/dashboard": 6225,
	"./TallyClinic/dashboard.vue": 6225,
	"./TallyClinic/dashboard_1": 99327,
	"./TallyClinic/dashboard_1.vue": 99327,
	"./TallyClinic/dashboard_2": 54042,
	"./TallyClinic/dashboard_2.vue": 54042,
	"./TallyClinic/dashboard_view": 61732,
	"./TallyClinic/dashboard_view.vue": 61732,
	"./TallyClinic/new_dashboard": 19451,
	"./TallyClinic/new_dashboard.vue": 19451,
	"./TallyClinic/tallyClinicAppLayout": 16005,
	"./TallyClinic/tallyClinicAppLayout.vue": 16005,
	"./TallyClinic/temp_dashboard": 51803,
	"./TallyClinic/temp_dashboard.vue": 51803,
	"./Teams/Create": 29933,
	"./Teams/Create.vue": 29933,
	"./Teams/Partials/CreateTeamForm": 77321,
	"./Teams/Partials/CreateTeamForm.vue": 77321,
	"./Teams/Partials/DeleteTeamForm": 81857,
	"./Teams/Partials/DeleteTeamForm.vue": 81857,
	"./Teams/Partials/TeamMemberManager": 99598,
	"./Teams/Partials/TeamMemberManager.vue": 99598,
	"./Teams/Partials/UpdateTeamNameForm": 36903,
	"./Teams/Partials/UpdateTeamNameForm.vue": 36903,
	"./Teams/Show": 64681,
	"./Teams/Show.vue": 64681,
	"./TermsOfService": 76012,
	"./TermsOfService.vue": 76012,
	"./Welcome": 18220,
	"./Welcome.vue": 18220,
	"./products/inventorydetail": 14867,
	"./products/inventorydetail.vue": 14867,
	"./products/paydetail": 9,
	"./products/paydetail.vue": 9,
	"./weekoff": 47681,
	"./weekoff.vue": 47681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88846;